var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-section quote"},[_c('blockquote',{staticClass:"block-quotation"},[_vm._v(_vm._s(_vm.$prismic.richTextAsPlain(_vm.slice.primary.quote_text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }